// extracted by mini-css-extract-plugin
export default {"skillBlock":"Skill_skillBlock__MxTjN","square":"Skill_square__jwH4v"};